export default {
  getSectionLineItemAudit: (state) => state.sectionLineItemAudit,
};
